import React from 'react';
import {Flex, Text} from '@priority-software/priority-style-react';
import {renderGeneratorNewState} from '../../../../renderGenerator';
import {AIButton} from '../../../../../../components/AIButton/AIButton';
import texts from '../../../../../../Localization/AISearch/texts';
import {allowAISearch} from '../../utils';

export const PromotionBlock = () => {
    if (!allowAISearch()) {
        return null;
    }
    return (
        <Flex direction="column" alignItems="center" style={{gap: 16}}>
            <Text skin="paragraph-1">{texts.ai_search_promotion_text}</Text>
            <AIButton
                onClick={() => renderGeneratorNewState({isAISearch: true})}
                text={texts.ai_label}
            />
        </Flex>
    );
};
